export const PIXEL_CONVERSIONS = {
    NO_PIXEL_NO_CONVERSIONS: 'NO_PIXEL_NO_CONVERSIONS',
    HAS_PIXEL_NO_CONVERSIONS: 'HAS_PIXEL_NO_CONVERSIONS',
    HAS_PIXEL_HAS_CONVERSIONS: 'HAS_PIXEL_HAS_CONVERSIONS',
};

export default PIXEL_CONVERSIONS;
